import styled from "styled-components";

const Card = ({ text, icon, title, animation }) => {
  return (
    <Wrapper>
      <TopWrap>
        <Icon src={icon} />
        <Title>{title}</Title>
      </TopWrap>
      <TextWrap>{text}</TextWrap>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-around; */
  align-items: center;
  border-radius: 12px;
  background: hsl(0, 0%, 90%);
  width: clamp(300px, 28%, 80%);
  min-height: 300px;
  height: 100%;
  padding: 50px 25px 25px;
  box-shadow: 0px 11px 25px 0px rgb(49 49 49 / 19%);
  text-align: justify;
  overflow: auto;
  background-color: var(--main-color);
  color: black;
  -webkit-box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  margin: 5px;

  @media (max-width: 1000px) {
    padding: 15px;
    min-height: 0;
    margin: 10px 0;
  }
`;

const Title = styled.h4`
  font-size: 2.4rem;
  padding: 5px;
  color: white;
`;

const Icon = styled.img`
  height: 50px;
  width: auto;
  margin-bottom: 12px;
`;

const TopWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 12px;
`;

const TextWrap = styled.div`
  background: white;
  padding: 8px 12px;
  border-radius: 8px;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: black solid 1px; */
  -webkit-box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
`;

export default Card;
